import getReport from '@/report/create'

type ClickSource =
  | 'back'
  | 'download'
  | 'accout'
  | 'rule'
  | 'record'
  | 'anniversary'
  | 'market'
  | 'gift_box'
  | 'shareA'
  | 'FBshare'
  | 'TWshare'
  | 'sales_records'
  | 'random_sale'
  | 'specific_sale'
  | 'shareB'
  | 'FBshare2'
  | 'TWshare2'
  | 'shareDownload'
  | 'buy'
  | 'refresh'
  | 'reward'

export const clickReport = (source: ClickSource) => {
  const $report = getReport()

  if (!$report) return

  try {
    return $report('h5EventButtonChick', {
      clickSource: source,
      round: String(window.inSDK ? 1 : 2),
    })
    // eslint-disable-next-line no-empty
  } catch (_) {}
}
window.__clickReport__ = clickReport
